import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FileService } from 'src/app/services/file/file.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.sass']
})
export class ViewUserComponent implements OnInit {
  id
  avatar
  user
  userServiceSub: Subscription;
  fileServiceSub: Subscription;

  constructor(
    private userService: UserService,
    private fileService: FileService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userServiceSub = this.userService.findOwn().subscribe(res => {
      this.user = res
      if (res.avatar?.id) {
        this.fileServiceSub = this.fileService.findOne(res.avatar.id).subscribe(res => {
          this.avatar = res.url ? `url("${res.url_small || res.url}")` : 'url(/assets/images/avatar.svg)'
        })
      } else {
        this.avatar = 'url(/assets/images/avatar.svg)'
      }
    })
  }

  onEdit() {
    this.router.navigate(['/profile', 'edit'])
  }
}
